module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_costumes-924c636393374240c51ad4b677b29c25.jpg";